<template>
  <div>
    <div class="tip" style="margin-bottom: 20px">
      <b>商品信息只支持一级包含关系</b>
      <ol>
        <li>确保该商品不包含在其他商品包中</li>
        <li>选择的下级商品不能包含其他商品</li>
      </ol>
    </div>
    <!--表格-->
    <el-table v-loading="loading" :data="datalist">
      <el-table-column label="操作" width="50" align="center">
        <template slot="header">
          <el-link type="primary" icon="el-icon-circle-plus" @click="onPlus()" />
        </template>
        <template slot-scope="scope">
          <el-link type="danger" icon="el-icon-remove" @click="onRemove(scope)" />
        </template>
      </el-table-column>
      <el-table-column prop="Name" label="商品名称" min-width="200" show-overflow-tooltip />
      <el-table-column label="单价" min-width="100">
        <template slot-scope="{ row }">
          <label class="text-price text-danger">{{ row.Price }}</label>
        </template>
      </el-table-column>
      <el-table-column prop="Amount" label="数量" width="160">
        <template slot-scope="{ row }">
          <el-input v-model="row.Amount" size="small">
            <template slot="append">{{ row.Unit }}</template>
          </el-input>
        </template>
      </el-table-column>
    </el-table>
    <div style="margin-top: 20px">
      <el-button type="primary" @click="onSubmit()">保存</el-button>
    </div>
  </div>
</template>

<script>
import goodsPicker from '../_picker.vue'
export default {
  data () {
    return {
      loading: false,
      goodsId: this.$route.params?.id,
      datalist: [],
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    // 信息列表
    loadData () {
      this.loading = true
      this.$apis.mall.goods.getItems({
        goodsId: this.goodsId
      }).then((res) => {
        this.datalist = res
      }).catch((e) => {
        this.$message.error(e)
      }).finally(() => {
        this.loading = false
      })
    },

    //选择商品
    onPlus () {
      this.$layer.iframe({
        title: '选择商品',
        area: ['640px', '500px'],
        content: {
          content: goodsPicker,
          parent: this,
          data: {
            callback: (res) => {
              res.forEach(item => {
                if (this.datalist.findIndex(x => x.Id == item.Id) == -1) {
                  this.$set(item, "Amount", 1)
                  this.datalist.push(item)
                }
              })
            }
          }
        }
      })
    },

    //移除商品
    onRemove (row) {
      this.datalist.splice(row.$index, 1)
    },


    //提交保存
    onSubmit () {
      this.loading = true
      let _items = {}
      this.datalist.forEach(m => {
        _items[m.Id] = parseInt(m.Amount)
      })
      this.$apis.mall.goods.setItems({
        GoodsId: this.goodsId,
        Items: _items
      }).then(() => {
        this.$message({ message: "数据提交成功！", type: "success" })
        this.loadData()
      }).catch(e => {
        this.$message.error(e || "执行错误")
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>


<style lang="scss" scoped>
ol {
  margin-left: 16px;
}
</style>